enum types {
  SET_VIEW_PORT = 'SET_VIEW_PORT'
}

export default types
